import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SafePipeModule } from 'app/pipes/safe.pipe.module';
import { NgxUnleashProxyClientModule } from 'shared/unleash/ngx-unleash-proxy-client.module';

import { SupersetEmbedModule } from '../../../../app/superset/superset-embed.module';
import { ContactsAnalyticsComponent } from './contacts-analytics.component';

@NgModule({
	declarations: [ContactsAnalyticsComponent],
	imports: [
		NgxUnleashProxyClientModule,
		CommonModule,
		SafePipeModule,
		SupersetEmbedModule,
	],
	exports: [ContactsAnalyticsComponent],
	providers: [],
})
export class ContactsAnalyticsModule {}
